import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { ICPLTextEditorImageUploadClient } from "./api/cplapi/CPLAPI";

export interface ITextEditorImageUploadService {
  uploadImage(image: File): Promise<string>;
}

@injectable()
export class TextEditorImageUploadService implements ITextEditorImageUploadService {
  @inject(SERVICE_TYPES.CPLTextEditorImageUploadClient)
  cplTextEditorImageUploadClient!: ICPLTextEditorImageUploadClient;

  async uploadImage(image: File): Promise<string> {
    const imageUploadResult = await this.cplTextEditorImageUploadClient.uploadImage({
      image: { data: image, fileName: image.name },
    });
    return `${process.env.REACT_APP_CPL_API_BASE_URI}/api/TextEditorImageRetrieval/GetImage?documentID=${imageUploadResult.documentID}&savePath=${imageUploadResult.savePath}`;
  }
}
